export const lists = [
    {
        title: 'Musioについて',
        q: [
            {
                question: '使用の際にどのような環境が必要ですか？',
                answer:
                    'Wi-Fi環境が必要です。なお、ご使用時にMusioをWi-Fi接続していただきます。',
            },
            {
                question: '複数人で使用できますか？',
                answer:
                    '学習の際は複数名様でご使用いただけます。',
            },
        ],
    },
    {
        title: 'お申込み',
        q: [
            {
                question: '申込後にキャンセルはできますか？',
                answer:
                    'お申込後のキャンセルは承っておりません。お申込の際は十分ご注意ください。\n ' +
                    'また、ご不明な点がございましたらサポートセンターまでお問い合わせください。',
            },
            {
                question: '申込後にメールが届かないのはなぜですか？',
                answer:
                    '以下のような原因が考えられますのでご確認ください。\n\n ' +
                    '- ご登録のメールアドレスが間違っている\n ' +
                    '- 迷惑メールボックスに入っている\n ' +
                    '- メールボックスの容量が一杯で受け取れなくなっている\n ' +
                    '- ドメイン指定受信をしている（「akaintelligence.com」を受信できるように設定してください。）',
            },
        ],
    },
    {
        title: 'ご利用料金',
        q: [
            {
                question: 'キャンペーン期間終了後も、キャンペーン価格で利用できますか？',
                answer:
                    'キャンペーン期間中にお申込みいただきますと、キャンペーン終了後もキャンペーン価格にてお使いいただけます。',
            },
            {
                question: '送料はかかりますか？',
                answer:
                    'ご退会時に配送手数料2,300円をいただいております。',
            },
        ],
    },
    {
        title: 'お支払い',
        q: [
            {
                question: '月額利用料金が発生するタイミングはいつですか？',
                answer:
                    'ご利用申込後、無料期間の終了翌日から月額利用料金が発生いたします。尚、無料期間終了後から翌月までに利用日数が1か月に満たない場合は、月額料金の日割り料金を発生時に請求します。',
            },
            {
                question: '途中で解約した場合、お支払いはどうなりますか？',
                answer:
                    'お支払い方法によって異なります。下記をご参照ください。\n\n' +
                    '<毎月払いの場合>\n' +
                    '利用終了の申込をされた月を最後の月として、1ヵ月分の月額利用料金が発生いたします。\n' +
                    'できる限り月末に利用終了のお申込をされることをお勧めしています。\n\n' +
                    '<12ヵ月分一括払いの場合>\n' +
                    '返金はいたしかねます。そのため、1年間以上のご使用予定がない場合は毎月払いでのお支払いをおすすめしております。',
            },
        ],
    },
    {
        title: '故障・不具合',
        q: [
            {
                question: '故障・不具合の場合',
                answer: 'お申込み時にメールにてお送りしますユーザーガイドのガイドラインに従った通常の使用時における初期不良・故障の場合は、無料で修理・交換します。お客様の不注意による故障により修理・交換が必要な場合は、修理・交換費用、送料をお支払いいただきます。',
            },
        ],
    },
    {
        title: '紛失',
        q: [
            {
                question: '紛失の場合',
                answer:
                    '弊社のサポートセンターにお問い合わせください。\n ' +
                    '紛失の場合は、Musioの消費者価格に相当する金額のご請求が発生します。',
            },
        ],
    },
    {
        title: '解約',
        q: [
            {
                question: '解約方法',
                answer:
                    '会員登録時に発行するマイページからご解約いただけます。なお、解約料はかかりません。\n ' +
                    '解約申請日基準で、翌月末のご解約となります。\n ' +
                    '(例）10月15日の解約申請の場合、翌月末の11月31日のご解約となります。\n ' +
                    '12月1日以降は決済されません。',
            },
            {
                question: '返却方法',
                answer: 
                    '解約申請の際に、Musioの返却（集荷）日を決めていただきます。\n ' +
                    '解約完了日の15日後までの間で返却日を設定していただきます。\n ' +
                    '返却日になりましたら、弊社提携の配送会社がお伺いしますので、返却するMusio及び付属物を\n ' +
                    'お届け時のダンボールに梱包の上お渡しください。',
            },
            {
                question: '返却が遅れる場合',
                answer: 
                    '返却されない場合には、通常の月額料金の決済が継続しますのでご注意ください。\n '+
                    '返却が遅れる場合は、サポートセンターにご連絡ください。',

            },
        ],
    },
]
